<template>
  <div v-html="year.turn_in_entry_text"></div>
  <EntrySubmissionComponent
    :year="year"
    :submission-entry-form="data"
    :submission-id="submissionId"></EntrySubmissionComponent>
</template>
<script setup lang="ts">
import EntrySubmissionComponent from '@/components/entry/EntrySubmissionComponent.vue';
import { ITeamCriteriaDTO, ITeamDTO, IYearDTO } from '@/dtos';
import { useSubmissionnStore } from '@/stores';
import { computed, watch } from 'vue';

interface Props {
  registration: ITeamCriteriaDTO;
  year: IYearDTO;
  team: ITeamDTO;
}

const props = defineProps<Props>();
const registration = computed(() => props.registration);
const year = computed(() => props.year);
const submissionId = computed(() => registration.value?.submissions[0]?.id ?? '');
const submissionStore = useSubmissionnStore();
const { data } = submissionStore.getSubmissionEntryQuery(submissionId);

watch(
  data,
  async (newVal) => {
    if (newVal) {
      if (!newVal || !newVal.id) {
        await submissionStore.createEntry.mutateAsync(submissionId.value);
        return;
      }
    }
  },
  { immediate: true },
);
</script>
